import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[scroll-top-on-condition]'
})
export class ScrollTopDirective {
    @Input() condition: boolean;
    constructor(public elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            let element: any = this.elRef.nativeElement;
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        });
    }
} 



// WEBPACK FOOTER //
// ./src/app/directives/scroll-top-on-condition.ts